<template v-bind:is="currentTabComponent" >

   <spinner v-if="!loaded" ></spinner>


    <div class="page template-padding pt-4" v-else-if="loaded" >
        
        <div class="" >
            <ul class="horizontal-menu" > 
                <li>  
                    <router-link :to="{name: 'Organizations'}" class="not-active" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>
                </li>
                
                <li>
                    <router-link :to="{name: 'OrganizationDetails', params: { ID: ID }}" class="h3 text-bold" > Info </router-link>
                </li>
                
                <li>
                    <router-link :to="{name: 'OrgLeads', params: { passed_organizationID: ID }}" ref="tags" class="h3 text-bold" > Leads </router-link>
                </li>
                
                <li>
                    <router-link :to="{name: 'OrgUsers', params: { ID: ID }}" ref="tags" class="h3 text-bold" > Users </router-link>
                </li>
                
                <li>
                    <router-link :to="{name: 'OrgEvents', params: { ID: ID }}" ref="tags" class="h3 text-bold" > Events </router-link>
                </li>
                
                <li class=" float-right" >  
                    
                    <b-dropdown size="sm" html='Actions <svg aria-hidden="true" class="atlass-icon icon-chevron-down fill-white" height="14" width="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fill-rule="evenodd"></path></svg>' variant="primary" right split-variant class="font-size-14">
                        <b-dropdown-item-button @click="logIntoOrganization()" > <font-awesome-icon icon="sign-in-alt" ></font-awesome-icon> Log into organization </b-dropdown-item-button>
                        <b-dropdown-item-button class="" @click="seeCache()"  >See Cached Data</b-dropdown-item-button>
                        <b-dropdown-item-button class="" @click="clearCache()"  >Clear Cache</b-dropdown-item-button>
                        <b-dropdown-item-button class="d-none" >Edit</b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button variant="danger" @click="preventDelete()" > <font-awesome-icon icon="trash" ></font-awesome-icon> Delete </b-dropdown-item-button>
                    </b-dropdown>
                    
                </li>
            </ul>
        </div>
        
        <div class=" " >
            <router-view :key="$route.path" ></router-view>
        </div>
        
    </div>
</template>

<script>
import { AUTH_INTO_ORG } from '@/store/actions/auth'
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';    
    
export default {
    name: 'Organization',
    components:{
    },
    props: {
        ID: { 
            type: [Number, String],
        }
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            docID: this.ID,
            type: 'page'
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        //this.get_data();
        this.loaded = true;
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){
             
            var ref = firebase.firestore().collection('organizations').doc( this.ID )
            return ref.get()
                .then((snapshot) => {
                    //console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                })
            
        },
        formatDate(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        copy( text ){
            
            let textToCopy = text
            navigator.clipboard.writeText(textToCopy);
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        },
        logIntoOrganization(){
            let orgID = this.data.id;
            let orgName = this.data.name;
            
            if( firebase.auth().currentUser ){
                firebase
                    .auth()
                    .currentUser.getIdTokenResult()
                    .then(tokenResult => {
                        //console.log(tokenResult.claims);
                        let uid = tokenResult.claims.user_id
                        //console.log(uid)
                        let user = firebase
                            .firestore()
                            .collection("users")
                            .doc(uid)

                        user.get().then(function(doc) {
                            if (doc.exists) {
                                console.log("Document data:", doc.data());

                                let user = doc.data()
                                if( user.admin ){
                                    //USER IS ADMIN
                                    //SET COOKIE FOR LOGGED IN ORGANIZATION
                                    let settings = this.data.settings
                                    settings.datetime = this.data.datetime
                                    let org = {"ID": orgID, "name": orgName, "settings": settings }
                                    
                                    this.$store.dispatch(AUTH_INTO_ORG, org ).then(response => {
                                        //this.$router.push({ name: 'Analyze'});
                                    })
                                    //this.$router.push({ name: 'Analyze' });
                                }
                            
                                //Cookies.set('user', btoa( JSON.stringify( doc.data() ) ) , null, null, null, false, true ) 
                                //router.push({ name: 'Onboarding', params: { APPKEY: APPKEY }},);
                            } else {
                                // doc.data() will be undefined in this case
                                console.log("No such document!");

                            }
                        }.bind(this)).catch(function(error) {
                            console.log("Error getting document:", error);
                        });
                    });
            }

        },
        
        preventDelete( ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the organization will be deleted indefinitely',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.delete( );
                    
                }
            })
            
        },   
        
        delete(){
            
            console.log( this.data )
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": Cookies.get('user-token') }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/admin/delete-organization', 
                headers: headers, 
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "organizationID": this.data.APPKEY
                } 
            })
            .then(resp => {
                //console.log(resp)
                
                if( resp.data.status == 103 ){
                    
                    this.$swal({
                        title: 'Refresh required',
                        text: 'Please reload the page in order to refresh the session token ',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, refresh'
                    }).then((result) => {
                        if (result.value) { 
                            window.location.reload()
                        }
                    })
                    
                }else{
                    
                    this.$toast.success({
                        title: 'Success',
                        message: 'Order deleted'
                    })
                    
                }
                
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error deleting organization. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        seeCache(){
                        
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": Cookies.get('user-token') }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/app/check-cache', 
                headers: headers, 
                data: { 
                    "APPKEY": this.data.APPKEY
                } 
            })
            .then(resp => {
                console.log(resp)
                
                
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error:'+error
                })
                
            }); //end axios 
            
        },
        
        clearCache(){
                        
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": Cookies.get('user-token') }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/app/clear-cache', 
                headers: headers, 
                data: { 
                    "APPKEY": this.data.APPKEY
                } 
            })
            .then(resp => {
                console.log(resp)
                
                
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error:'+error
                })
                
            }); //end axios 
            
        }

    },
    watch: {
   
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/admin/Organization.vue